import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-[#1E3A5F] text-white hover:bg-[#152d4a] focus-visible:ring-[#1E3A5F]',
    secondary: 'bg-[#8BA888] text-white hover:bg-[#7a9677] focus-visible:ring-[#8BA888]',
    outline: 'border-2 border-[#8BA888] text-[#8BA888] hover:bg-[#8BA888]/10 focus-visible:ring-[#8BA888]',
    ghost: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-149">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-150" />}
      {children}
    </button>;
}